exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul {\r\n    list-style-type: none;\r\n    padding-left: 20px;\r\n}\r\n\r\nli {\r\n    margin: 10px 0;\r\n    border-top: solid 3px #a2bee5;\r\n    padding-top: 6px;\r\n}\r\n\r\nli>span {\r\n    cursor: pointer;\r\n}\r\n\r\n.fa-fw {\r\n    color: #a2bee5;\r\n    font-size: 12px;\r\n}\r\n\r\n@media screen and (max-width: 576px) {\r\n    .fa-fw {\r\n        font-size: 14px;\r\n    }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/apache/localhost/www/Angular/task2/src/app/child/child.component.css
// module id = ../../../../../src/app/child/child.component.css
// module chunks = 1